import { render, staticRenderFns } from "./Mentor.vue?vue&type=template&id=cbf6ad6e&scoped=true&"
import script from "./Mentor.vue?vue&type=script&lang=js&"
export * from "./Mentor.vue?vue&type=script&lang=js&"
import style0 from "./Mentor.vue?vue&type=style&index=0&id=cbf6ad6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf6ad6e",
  null
  
)

export default component.exports